export default __webpack_public_path__ + "static/media/scrabble-480w.52b73dca.png";